import type { ProductFeature } from "../types";

export function formatBytes(bytes: number) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1073741824) return `${(bytes / 1048576).toFixed(1)} MB`;
  return `${(bytes / 1073741824).toFixed(1)} GB`;
}

export function fileExtension(name: string) {
  return name.split(".").pop()?.toUpperCase() ?? "FILE";
}

export function isPhotoFile(contentType: string) {
  return contentType.startsWith("image/");
}

export function featureName(feature: ProductFeature) {
  return typeof feature === "string" ? feature : feature.name;
}

export function featureDetails(feature: ProductFeature) {
  return typeof feature === "string" ? "" : feature.focus || feature.description || "";
}

export function linesFromFeatures(features?: ProductFeature[]) {
  return (features || []).map((feature) => `${featureName(feature)} | ${featureDetails(feature)}`.trim()).join("\n");
}

export function toggleCsvValue(value: string | undefined, key: string) {
  const values = new Set((value || "").split(",").map((item) => item.trim()).filter(Boolean));
  values.has(key) ? values.delete(key) : values.add(key);
  return Array.from(values).join(",");
}
